'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _ajax = require('../utils/ajax');

var _ajax2 = _interopRequireDefault(_ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Microsoft grants you the right to use these script files for the sole
 * purpose of either: (i) interacting through your browser with the Microsoft
 * website or online service, subject to the applicable licensing or use
 * terms; or (ii) using the files as included with a Microsoft product subject
 * to that product's license terms. Microsoft reserves all other rights to the
 * files not expressly granted by Microsoft, whether by implication, estoppel
 * or otherwise. Insofar as a script file is dual licensed under GPL,
 * Microsoft neither took the code under GPL nor distributes it thereunder but
 * under the terms set out in this paragraph. All notices and licenses
 * below are for informational purposes only.
 /*!
 ** Unobtrusive Ajax support library for jQuery
 ** Copyright (C) Microsoft Corporation. All rights reserved.
 */

/*jslint white: true, browser: true, onevar: true, undef: true, nomen: true, eqeqeq: true, plusplus: true, bitwise: true, regexp: true, newcap: true, immed: true, strict: false */
/*global window: false, jQuery: false */

var data_click = "unobtrusiveAjaxClick";

// initializer fake
/**
 *  REPLACEMENT FOR jquery-unobtrusive-ajax library
 *  Includes initializer / finalizer triggers
 *  default callbacks
 *  ...
 *  most of the logic has been moved to utils/ajax.js
 */

var data_target = "unobtrusiveAjaxClickTarget";
var data_validation = "unobtrusiveValidation";

(0, _jquery2.default)(document).on("click", "a[data-ajax=true]", function (evt) {
	evt.preventDefault();
	(0, _ajax2.default)({
		target: this,
		url: this.href,
		method: (0, _jquery2.default)(this).attr('data-method') || "GET",
		data: []
	});
});

(0, _jquery2.default)(document).on("click", "form[data-ajax=true] input[type=image]", function (evt) {
	var name = evt.target.name;
	var target = (0, _jquery2.default)(evt.target);
	var form = (0, _jquery2.default)(target.parents("form")[0]);
	var offset = target.offset();

	form.data(data_click, [{ name: name + ".x", value: Math.round(evt.pageX - offset.left) }, { name: name + ".y", value: Math.round(evt.pageY - offset.top) }]);

	setTimeout(function () {
		form.removeData(data_click);
	}, 0);
});

(0, _jquery2.default)(document).on("click", "form[data-ajax=true] :submit", function (evt) {
	var name = evt.currentTarget.name;
	var target = (0, _jquery2.default)(evt.target);
	var form = (0, _jquery2.default)(target.parents("form")[0]);

	form.data(data_click, name ? [{ name: name, value: evt.currentTarget.value }] : []);
	form.data(data_target, target);

	setTimeout(function () {
		form.removeData(data_click);
		form.removeData(data_target);
	}, 0);
});

(0, _jquery2.default)(document).on("submit", "form[data-ajax=true]", function (evt) {
	var clickTarget = (0, _jquery2.default)(this).data(data_target);
	evt.preventDefault();
	var isCancel = clickTarget && clickTarget.hasClass("cancel");
	if (!isCancel && !validate(this)) {
		return;
	}

	(0, _ajax.submitForm)(this, clickTarget);
});

function validate(form) {
	var validationInfo = (0, _jquery2.default)(form).data(data_validation);
	return !validationInfo || !validationInfo.validate || validationInfo.validate();
}


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/initializers/ajax.js
// module id = 493
// module chunks = 0